<template>
  <div class="row">
    <div
      :class="{
        'col-12':
          !updateConfig ||
          !updateConfig.class ||
          !createConfig ||
          !createConfig.class,

        [updateConfig.class]: updateConfig && updateConfig.class,
        [createConfig.class]: createConfig && createConfig.class,
      }"
    >
      <div :class="{ 'card card-custom mb-5': !simple }">
        <!-- Card Header  -->
        <div
          v-if="!simple"
          class="card-header pt-3 px-5 border-2 border-bottom"
        >
          <div v-if="form !== 'filter'" class="card-toolbar">
            <a
              v-if="!hideBtnBack && !$store.state.unknownRoute"
              @click="$router.go(-1)"
              class="btn btn-transparent btn-lg btn-icon btn-back mr-1"
              v-b-tooltip.top="$t('global.go_back')"
            >
              <i class="ri-arrow-left-circle-line text-primary p-0"></i>
            </a>
          </div>
          <h3 class="card-title align-items-start flex-column">
            <span
              class="card-label font-weight-bolder text-dark"
              v-if="form === 'create'"
            >
              {{ $t("global.form_add") }}
              <span v-if="titleKey">{{ $t(`menu.${titleKey}`) }}</span>
              <span v-else>{{ title }}</span>
            </span>
            <span
              v-else-if="form === 'update'"
              class="card-label font-weight-bolder text-dark"
            >
              {{ $t("global.form_edit") }}
              <span v-if="titleKey">{{ $t(`menu.${titleKey}`) }}</span>
              <span v-else>{{ title }}</span>
            </span>
            <span
              v-else-if="form === 'filter'"
              class="card-label font-weight-bolder text-dark"
            >
              {{ $t("global.form_filter") }}
              <span v-if="titleKey">{{ $t(`menu.${titleKey}`) }}</span>
              <span v-else>{{ title }}</span>
            </span>
            <span v-else class="card-label font-weight-bolder text-dark">{{
              title
            }}</span>
            <!-- <span class="text-muted mt-3 font-weight-bold font-size-sm">More than 400+ new members</span> -->
          </h3>
        </div>
        <!-- Title  -->
        <div v-else class="pb-0 px-2">
          <span
            class="card-label font-weight-bolder text-dark"
            v-if="form === 'create'"
          >
            {{ $t("global.form_add") }}
            <span v-if="titleKey">{{ $t(`menu.${titleKey}`) }}</span>
            <span v-else>{{ title }}</span>
          </span>
          <span
            v-else-if="form === 'update'"
            class="card-label font-weight-bolder text-dark"
          >
            {{ $t("global.form_edit") }}
            <span v-if="titleKey">{{ $t(`menu.${titleKey}`) }}</span>
            <span v-else>{{ title }}</span>
          </span>
          <span
            v-else-if="form === 'filter'"
            class="card-label font-weight-bolder text-dark"
          >
            {{ $t("global.form_filter") }}
            <span v-if="titleKey">{{ $t(`menu.${titleKey}`) }}</span>
            <span v-else>{{ title }}</span>
          </span>
          <span v-else class="card-label font-weight-bolder text-dark">{{
            title
          }}</span>
        </div>
        <div
          class="card-body"
          :class="[simple ? 'p-2' : 'py-2 mt-3']"
          v-if="isReady"
        >
          <slot name="form-header" v-bind:rowData="defaultData"></slot>
          <!-- <pre>{{ modelData }}</pre> -->
          <ValidationObserver v-slot="{ handleSubmit }" ref="baseForm">
            <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="off">
              <div class="row" :class="{ row: simple }">
                <template v-for="(fl, ix) in fields">
                  <div
                    v-if="
                      fl.autoFill === 'corporate' || fl.autofill === 'customer'
                    "
                    :key="'row-switch-' + fl.autoFill + ix"
                    class="pl-4 mt-2"
                  >
                    <b-form-checkbox
                      v-model="useContactCheck"
                      name="check-button"
                      switch
                      :checked="useContactCheck"
                      class="swtich-input-success"
                    >
                      <span
                        class="font-weight-bold"
                        :class="{
                          'text-muted': !useContactCheck,
                          'text-green': useContactCheck,
                        }"
                        >GUNAKAN NO. TELP &amp; EMAIL
                        {{
                          fl.autoFill === "corporate"
                            ? "PERUSAHAAN"
                            : "CUSTOMER"
                        }}</span
                      >
                    </b-form-checkbox>
                  </div>

                  <div
                    v-if="fl.show"
                    :class="{
                      'col-auto': simple,
                      'col-12': !fl.class,
                      [fl.class]: true,
                    }"
                    :key="ix + '-loop-col'"
                  >
                    <div
                      :class="{
                        'my-6': fl.labelGroup,
                      }"
                    >
                      <h6 class="text-muted font-size-sm mb-5">
                        {{ fl.labelGroup }}
                      </h6>
                    </div>
                    <!-- <div :class="{[fl.class] : true}"> -->
                    <!-- <div class="col-lg-12"> -->
                    <!-- Type Default  -->
                    <template v-if="defaultType.includes(fl.type)">
                      <div
                        class="form-group"
                        :key="ix + '-field'"
                        v-if="fl.show"
                      >
                        <ValidationProvider
                          mode="eager"
                          :name="fl.label"
                          :rules="fl.validation.join('|')"
                          v-slot="{ classes, errors }"
                        >
                          <label v-if="fl.type != 'hidden'"
                            >{{ fl.label }}
                            <span
                              v-if="fl.validation.includes('required')"
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <input
                            v-on="fl.event"
                            v-bind="fl.attr"
                            v-model.lazy.trim="
                              modelData[fl.view_data ? fl.view_data : fl.data]
                            "
                            :type="fl.type"
                            class="form-control"
                            :class="[fl.validation.length === 0 ? '' : classes]"
                            :placeholder="fl.placeholder"
                            :disabled="fl.disabled"
                          />
                          <div class="invalid-feedback">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </template>

                    <!-- Type Number -->
                    <template v-else-if="numberType.includes(fl.type)">
                      <div
                        class="form-group"
                        :key="ix + '-field'"
                        v-if="fl.show"
                      >
                        <ValidationProvider
                          mode="eager"
                          :name="fl.label"
                          :rules="fl.validation.join('|')"
                          v-slot="{ classes, errors }"
                        >
                          <label
                            >{{ fl.label }}
                            <span
                              v-if="fl.validation.includes('required')"
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <vue-numeric
                            separator="."
                            decimal-separator="."
                            :precision="fl.decimal ? 2 : 0"
                            :empty-value="0"
                            :currency="fl.type === 'money' ? 'Rp.' : null"
                            v-on="fl.event"
                            v-bind="fl.attr"
                            v-model.lazy="
                              modelData[fl.view_data ? fl.view_data : fl.data]
                            "
                            type="text"
                            class="form-control"
                            :class="[fl.validation.length === 0 ? '' : classes]"
                            :placeholder="fl.placeholder"
                            :disabled="fl.disabled"
                          />
                          <!-- <input v-on="fl.event" v-bind="fl.attr" v-number-input="fl.type" v-model.lazy="modelData[fl.data]" type="text" class="form-control" :class="[fl.validation.length===0 ? '' : classes]" :placeholder="fl.placeholder" /> -->
                          <div class="invalid-feedback">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </template>
                    <!-- Type Date -->
                    <template v-else-if="dateType.includes(fl.type)">
                      <div
                        class="form-group"
                        :key="ix + '-field'"
                        v-if="fl.show"
                      >
                        <ValidationProvider
                          mode="eager"
                          :name="fl.label"
                          :rules="fl.validation.join('|')"
                          v-slot="{ classes, errors }"
                        >
                          <label class="d-block"
                            >{{ fl.label }}
                            <span
                              v-if="fl.validation.includes('required')"
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <date-picker
                            v-on="fl.event"
                            v-bind="fl.attr"
                            :inline="!simple"
                            :input-attr="{ autocomplete: 'off' }"
                            v-model.lazy.trim="
                              modelData[fl.view_data ? fl.view_data : fl.data]
                            "
                            :type="fl.type"
                            :input-class="'form-control date-field'"
                            :class="[fl.validation.length === 0 ? '' : classes]"
                            :placeholder="fl.placeholder"
                            :value-type="formatDate(fl.type)"
                            :disabled="fl.disabled"
                          />
                          <div class="invalid-feedback">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </template>
                    <!-- Type Date Range -->
                    <template v-else-if="dateRangeType.includes(fl.type)">
                      <div
                        class="form-group"
                        :key="ix + '-field'"
                        v-if="fl.show"
                      >
                        <ValidationProvider
                          mode="eager"
                          :name="fl.label"
                          :rules="fl.validation.join('|')"
                          v-slot="{ classes, errors }"
                        >
                          <label
                            >{{ fl.label }}
                            <span
                              v-if="fl.validation.includes('required')"
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <date-picker
                            v-on="fl.event"
                            range
                            :input-attr="{ autocomplete: 'off' }"
                            v-model.lazy.trim="modelData[fl.data]"
                            :type="fl.type.split('-')[0]"
                            :input-class="'form-control'"
                            :class="[fl.validation.length === 0 ? '' : classes]"
                            :placeholder="fl.placeholder"
                            :value-type="formatDate(fl.type)"
                            :disabled="fl.disabled"
                          />
                          <div class="invalid-feedback">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </template>
                    <!-- Type Text -->
                    <template v-else-if="textType.includes(fl.type)">
                      <div
                        class="form-group"
                        :key="ix + '-field'"
                        v-if="fl.show"
                      >
                        <ValidationProvider
                          mode="eager"
                          :name="fl.label"
                          :rules="fl.validation.join('|')"
                          v-slot="{ classes, errors }"
                        >
                          <label
                            >{{ fl.label }}
                            <span
                              v-if="fl.validation.includes('required')"
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <textarea
                            v-on="fl.event"
                            v-model.lazy="modelData[fl.data]"
                            :input-attr="{ autocomplete: 'off' }"
                            class="form-control"
                            :class="[fl.validation.length === 0 ? '' : classes]"
                            :placeholder="fl.placeholder"
                            rows="3"
                            :disabled="fl.disabled"
                          ></textarea>
                          <div class="invalid-feedback">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </template>
                    <template v-else-if="fl.type === 'color'">
                      <div
                        class="form-group"
                        :key="ix + '-field'"
                        v-if="fl.show"
                      >
                        <ValidationProvider
                          mode="eager"
                          :name="fl.label"
                          :rules="fl.validation.join('|')"
                          v-slot="{ classes, errors }"
                        >
                          <label v-if="fl.type != 'hidden'"
                            >{{ fl.label }}
                            <span
                              v-if="fl.validation.includes('required')"
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <input
                            v-model="
                              modelData[fl.view_data ? fl.view_data : fl.data]
                            "
                            :type="fl.type"
                            class="form-control"
                            :class="[fl.validation.length === 0 ? '' : classes]"
                            :placeholder="fl.placeholder"
                            :disabled="fl.disabled"
                          />
                          <div class="invalid-feedback">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </template>
                    <!-- Type File -->
                    <template v-else-if="fileType.includes(fl.type)">
                      <div
                        class="form-group"
                        :key="ix + '-field'"
                        v-if="fl.show"
                      >
                        <ValidationProvider
                          mode="aggressive"
                          :name="fl.label"
                          :rules="fl.validation.join('|')"
                          v-slot="{ classes, errors }"
                        >
                          <label
                            >{{ fl.label
                            }}<span
                              v-if="fl.validation.includes('required')"
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <single-upload
                            v-on="fl.event"
                            v-if="fl.type === 'file'"
                            v-model="modelData[fl.data]"
                            :error="errors"
                            :classes="fl.validation.length === 0 ? {} : classes"
                            :placeholder="fl.placeholder"
                            :attr="fl.attr"
                          />
                          <multi-upload
                            v-on="fl.event"
                            v-else
                            v-model="modelData[fl.data]"
                            :error="errors"
                            :classes="fl.validation.length === 0 ? {} : classes"
                            :placeholder="fl.placeholder"
                            :attr="fl.attr"
                          />
                        </ValidationProvider>
                      </div>
                    </template>
                    <!-- Options Type -->
                    <template v-else-if="optionType.includes(fl.type)">
                      <div
                        class="form-group"
                        :key="ix + '-field'"
                        v-if="fl.show"
                      >
                        <ValidationProvider
                          mode="aggressive"
                          :name="fl.label"
                          :rules="fl.validation.join('|')"
                          v-slot="{ classes, errors }"
                        >
                          <!-- Hint -->
                          <template v-if="fl.hint">
                            <div
                              class="d-flex justify-content-start align-items-center"
                            >
                              <label style="margin-bottom: 0.15rem"
                                >{{ fl.label }}
                                <span
                                  v-if="fl.validation.includes('required')"
                                  class="text-danger"
                                  >*</span
                                >
                              </label>
                              <i
                                class="ri-question-line ml-2"
                                :id="'tooltip-target-' + fl.id"
                              ></i>
                              <b-popover
                                :target="'tooltip-target-' + fl.id"
                                triggers="hover"
                                placement="right"
                                custom-class="text-left"
                              >
                                {{ fl.hint }}
                              </b-popover>
                            </div>
                          </template>
                          <!-- Required  -->
                          <label v-else
                            >{{ fl.label }}
                            <span
                              v-if="fl.validation.includes('required')"
                              class="text-danger"
                              >*</span
                            >
                          </label>
                          <!-- Multi Select -->
                          <template
                            v-if="
                              fl.type === 'select' ||
                              fl.type === 'select-multiple' ||
                              fl.type === 'radio'
                            "
                          >
                            <!-- <v-select :param="tmp_param[fl.id]" v-on="fl.event" v-model="modelData[fl.data]" :reduce="x => x.code"
                              :appendToBody="true" :disabled="true" class="vs-style" :options="tmp_option[fl.id]"
                              :placeholder="fl.placeholder" :class="[fl.validation.length === 0 ? '' : classes]"
                              :multiple="fl.type === 'select-multiple'">
                              <slot name="no-options">{{ $t('error.no_data') }}</slot>
                            </v-select> -->
                            <!-- :disabled="item.disabled" v-bind="item.attr" -->
                            <!-- <v-select

                              v-on:input="$emit('input', $event)"
                              v-model="modelData[fl.data]"
                              :reduce="x => x.code"
                              :appendToBody="item.notAppendToBody ? false : true"
                              class="vs-style"
                              :options="tmp_options"
                              :placeholder="item.placeholder || null"
                              :class="[
                                item.validation.length > 0 ? classes : item.nm ? 'mb-0' : 'mb-0',
                                item.ic,
                                item.classItem
                              ]"
                              @search="searchDataOption"
                              @search:focus="initialDataOption"
                            >

                            </v-select> -->
                            <s-input
                              v-model="modelData[fl.data]"
                              :item="{
                                classLabel: 'col pl-0',
                                rowclass: 'mx-0',
                                label: fl.label,
                                hideLabel: true,
                                prefix: '',
                                type: fl.type,
                                validation: fl.validation,
                                placeholder: '',
                                default: '',
                                api: fl.getter,
                                param: tmp_param[fl.id],
                                model_data: fl.data,
                                defaultCaption: defaultCaption[fl.data],
                                pointer: fl.option.list_pointer,
                                options: fl.options,
                              }"
                            />
                          </template>
                          <template v-else>
                            <div
                              v-if="tmp_option[fl.id]"
                              :class="[
                                fl.validation.length === 0 ? '' : classes,
                                fl.class ? fl.class : fl.type + '-inline',
                              ]"
                              class="mt-2"
                            >
                              <template v-for="(o, i) in tmp_option[fl.id]">
                                <label
                                  :class="fl.type"
                                  :key="i"
                                  :for="fl.data + '-' + i"
                                  :id="'label-' + fl.data + '-' + i"
                                  class="mr-5"
                                >
                                  <input
                                    :type="fl.type"
                                    :id="fl.data + '-' + i"
                                    :name="fl.data + '-' + i"
                                    :value="o.code"
                                    v-model="modelData[fl.data]"
                                  />
                                  <span></span>
                                  <a :id="'text-' + fl.data + '-' + i">{{
                                    o.label ? o.label : o
                                  }}</a>
                                </label>
                                <b-popover
                                  v-if="o.tooltip"
                                  :key="i + '-option-tooltip'"
                                  :target="'text-' + fl.data + '-' + i"
                                  :title="
                                    o.label
                                      ? 'Keterangan ' + o.label
                                      : 'Keterangan ' + o
                                  "
                                  triggers="hover"
                                  :placement="'right'"
                                  :boundary="'window'"
                                >
                                  <div
                                    v-for="(t, i) in o.tooltip"
                                    :key="i + '-tooltip-body'"
                                  >
                                    <span class="font-weight-bold">{{
                                      t.title
                                    }}</span>
                                    <p class="mt-0">{{ t.data }}</p>
                                  </div>
                                </b-popover>
                              </template>
                            </div>
                            <p v-else class="p-0">{{ $t("error.no_data") }}</p>
                          </template>
                          <div class="invalid-feedback">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </template>
                    <!-- Type Lookup -->
                    <template v-else-if="lookupType.includes(fl.type)">
                      <div
                        class="form-group"
                        :key="ix + '-field'"
                        v-if="fl.show"
                      >
                        <ValidationProvider
                          mode="aggressive"
                          :name="fl.label"
                          :rules="fl.validation.join('|')"
                          v-slot="{ classes, errors }"
                        >
                          <label
                            >{{ fl.label }}
                            <span
                              v-if="fl.validation.includes('required')"
                              class="text-danger"
                              >*</span
                            ></label
                          >
                          <lookup-input
                            v-on="fl.event"
                            v-model="modelData[fl.data]"
                            :defaultData="{ id: fl.id, data: defaultData }"
                            :multiple="fl.type === 'lookup-checkbox'"
                            :endpoint="fl.getter"
                            :param="tmp_param[fl.id]"
                            :errors="errors"
                            :title="fl.label"
                            :pointer="fl.option.list_pointer"
                            :classes="fl.validation.length === 0 ? {} : classes"
                            :placeholder="fl.placeholder"
                            :allowAdd="fl.option.allowAdd"
                          />
                        </ValidationProvider>
                      </div>
                    </template>
                    <!-- Type Slave -->
                    <template v-else-if="fl.type == 'slave'">
                      <div class="my-1">
                        <h3 class="text-primary mb-2">
                          {{ fl.option.slave_label }}
                        </h3>
                        <!-- start row slave  -->
                        <div class="row">
                          <div
                            class="col-auto"
                            v-for="(fls, index) in fl.fields[form]"
                            :id="fls.id"
                            :key="index"
                          >
                            <!-- Type Default  -->
                            <template v-if="defaultType.includes(fls.type)">
                              <div
                                class="form-group"
                                :key="ix + '-field'"
                                v-if="fls.show"
                              >
                                <ValidationProvider
                                  mode="eager"
                                  :name="fls.label"
                                  :rules="fls.validation.join('|')"
                                  v-slot="{ classes, errors }"
                                >
                                  <label v-if="fls.type != 'hidden'"
                                    >{{ fls.label }}
                                    <span
                                      v-if="fls.validation.includes('required')"
                                      class="text-danger"
                                      >*</span
                                    ></label
                                  >
                                  <input
                                    v-on="fls.event"
                                    v-bind="fls.attr"
                                    v-model.lazy.trim="modelData[fls.data]"
                                    :type="fls.type"
                                    class="form-control"
                                    :class="[
                                      fls.validation.length === 0
                                        ? ''
                                        : classes,
                                    ]"
                                    :placeholder="fls.placeholder"
                                  />
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </ValidationProvider>
                              </div>
                            </template>
                            <!-- Type Number -->
                            <template v-else-if="numberType.includes(fls.type)">
                              <div
                                class="form-group"
                                :key="ix + '-field'"
                                v-if="fls.show"
                              >
                                <ValidationProvider
                                  mode="eager"
                                  :name="fls.label"
                                  :rules="fls.validation.join('|')"
                                  v-slot="{ classes, errors }"
                                >
                                  <label
                                    >{{ fls.label }}
                                    <span
                                      v-if="fls.validation.includes('required')"
                                      class="text-danger"
                                      >*</span
                                    ></label
                                  >
                                  <vue-numeric
                                    separator="."
                                    decimal-separator=","
                                    :empty-value="0"
                                    :precision="fls.decimal ? 2 : 0"
                                    :currency="
                                      fls.type === 'money' ? 'Rp.' : null
                                    "
                                    v-on="fls.event"
                                    v-bind="fls.attr"
                                    v-model.lazy="modelData[fls.data]"
                                    type="text"
                                    class="form-control"
                                    :class="[
                                      fls.validation.length === 0
                                        ? ''
                                        : classes,
                                    ]"
                                    :placeholder="fls.placeholder"
                                  />
                                  <!-- <input v-on="fls.event" v-bind="fls.attr" v-number-input="fls.type" v-model.lazy="modelData[fls.data]" type="text" class="form-control" :class="[fls.validation.length===0 ? '' : classes]" :placeholder="fls.placeholder" /> -->
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </ValidationProvider>
                              </div>
                            </template>
                            <!-- Type Date -->
                            <template v-else-if="dateType.includes(fls.type)">
                              <div
                                class="form-group"
                                :key="ix + '-field'"
                                v-if="fls.show"
                              >
                                <ValidationProvider
                                  mode="eager"
                                  :name="fls.label"
                                  :rules="fls.validation.join('|')"
                                  v-slot="{ classes, errors }"
                                >
                                  <label class="d-block"
                                    >{{ fls.label }}
                                    <span
                                      v-if="fls.validation.includes('required')"
                                      class="text-danger"
                                      >*</span
                                    ></label
                                  >
                                  <date-picker
                                    v-on="fls.event"
                                    v-bind="fls.attr"
                                    :inline="!simple"
                                    :input-attr="{ autocomplete: 'off' }"
                                    v-model.lazy.trim="modelData[fls.data]"
                                    :type="fls.type"
                                    :input-class="'form-control date-field'"
                                    :class="[
                                      fls.validation.length === 0
                                        ? ''
                                        : classes,
                                    ]"
                                    :placeholder="fls.placeholder"
                                    :value-type="formatDate(fls.type)"
                                  />
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </ValidationProvider>
                              </div>
                            </template>
                            <!-- Type Date Range -->
                            <template
                              v-else-if="dateRangeType.includes(fls.type)"
                            >
                              <div
                                class="form-group"
                                :key="ix + '-field'"
                                v-if="fls.show"
                              >
                                <ValidationProvider
                                  mode="eager"
                                  :name="fls.label"
                                  :rules="fls.validation.join('|')"
                                  v-slot="{ classes, errors }"
                                >
                                  <label
                                    >{{ fls.label }}
                                    <span
                                      v-if="fls.validation.includes('required')"
                                      class="text-danger"
                                      >*</span
                                    ></label
                                  >
                                  <date-picker
                                    v-on="fls.event"
                                    range
                                    :input-attr="{ autocomplete: 'off' }"
                                    v-model.lazy.trim="modelData[fls.data]"
                                    :type="fls.type.split('-')[0]"
                                    :input-class="'form-control'"
                                    :class="[
                                      fls.validation.length === 0
                                        ? ''
                                        : classes,
                                    ]"
                                    :placeholder="fls.placeholder"
                                    :value-type="formatDate(fls.type)"
                                  />
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </ValidationProvider>
                              </div>
                            </template>
                            <!-- Type Text -->
                            <template v-else-if="textType.includes(fls.type)">
                              <div
                                class="form-group"
                                :key="ix + '-field'"
                                v-if="fls.show"
                              >
                                <ValidationProvider
                                  mode="eager"
                                  :name="fls.label"
                                  :rules="fls.validation.join('|')"
                                  v-slot="{ classes, errors }"
                                >
                                  <label
                                    >{{ fls.label }}
                                    <span
                                      v-if="fls.validation.includes('required')"
                                      class="text-danger"
                                      >*</span
                                    ></label
                                  >
                                  <textarea
                                    v-on="fls.event"
                                    v-model.lazy="modelData[fls.data]"
                                    :input-attr="{ autocomplete: 'off' }"
                                    class="form-control"
                                    :class="[
                                      fls.validation.length === 0
                                        ? ''
                                        : classes,
                                    ]"
                                    :placeholder="fls.placeholder"
                                    rows="3"
                                  ></textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </ValidationProvider>
                              </div>
                            </template>
                            <!-- Type File -->
                            <template v-else-if="fileType.includes(fls.type)">
                              <div
                                class="form-group"
                                :key="ix + '-field'"
                                v-if="fls.show"
                              >
                                <ValidationProvider
                                  mode="aggressive"
                                  :name="fls.label"
                                  :rules="fls.validation.join('|')"
                                  v-slot="{ classes, errors }"
                                >
                                  <label
                                    >{{ fls.label
                                    }}<span
                                      v-if="fls.validation.includes('required')"
                                      class="text-danger"
                                      >*</span
                                    ></label
                                  >
                                  <single-upload
                                    v-on="fls.event"
                                    v-if="fls.type === 'file'"
                                    v-model="modelData[fls.data]"
                                    :error="errors"
                                    :classes="
                                      fls.validation.length === 0 ? {} : classes
                                    "
                                    :placeholder="fls.placeholder"
                                    :attr="fls.attr"
                                  />
                                  <multi-upload
                                    v-on="fls.event"
                                    v-else
                                    v-model="modelData[fls.data]"
                                    :error="errors"
                                    :classes="
                                      fls.validation.length === 0 ? {} : classes
                                    "
                                    :placeholder="fls.placeholder"
                                    :attr="fls.attr"
                                  />
                                </ValidationProvider>
                              </div>
                            </template>
                            <!-- Options Type -->
                            <template v-else-if="optionType.includes(fls.type)">
                              <div
                                class="form-group"
                                :key="ix + '-field'"
                                v-if="fls.show"
                              >
                                <ValidationProvider
                                  mode="aggressive"
                                  :name="fls.label"
                                  :rules="fls.validation.join('|')"
                                  v-slot="{ classes, errors }"
                                >
                                  <!-- Hint -->
                                  <template v-if="fls.hint">
                                    <div
                                      class="d-flex justify-content-start align-items-center"
                                    >
                                      <label style="margin-bottom: 0.15rem"
                                        >{{ fls.label }}
                                        <span
                                          v-if="
                                            fls.validation.includes('required')
                                          "
                                          class="text-danger"
                                          >*</span
                                        >
                                      </label>
                                      <i
                                        class="ri-question-line ml-2"
                                        :id="'tooltip-target-' + fls.id"
                                      ></i>
                                      <b-popover
                                        :target="'tooltip-target-' + fls.id"
                                        triggers="hover"
                                        placement="right"
                                        custom-class="text-left"
                                      >
                                        {{ fls.hint }}
                                      </b-popover>
                                    </div>
                                  </template>
                                  <!-- Required  -->
                                  <label v-else
                                    >{{ fls.label }}
                                    <span
                                      v-if="fls.validation.includes('required')"
                                      class="text-danger"
                                      >*</span
                                    >
                                  </label>
                                  <!-- Multi Select -->
                                  <template
                                    v-if="
                                      fls.type === 'select' ||
                                      fls.type === 'select-multiple'
                                    "
                                  >
                                    <!-- <v-select :param="tmp_param[fl.id]" v-on="fls.event" v-model="modelData[fls.data]" :reduce="x => x.code"
                                      :appendToBody="true" class="vs-style" :options="tmp_option[fls.id]"
                                      :placeholder="fls.placeholder" :disabled="true" :class="[fls.validation.length === 0 ? '' : classes]"
                                      :multiple="fls.type === 'select-multiple'">
                                      <slot name="no-options">{{ $t('error.no_data') }}</slot>
                                    </v-select> -->
                                  </template>
                                  <template v-else>
                                    <div
                                      v-if="tmp_option[fls.id]"
                                      :class="[
                                        fls.validation.length === 0
                                          ? ''
                                          : classes,
                                        fls.class
                                          ? fls.class
                                          : fls.type + '-inline',
                                      ]"
                                      class="mt-2"
                                    >
                                      <template
                                        v-for="(o, i) in tmp_option[fls.id]"
                                      >
                                        <label
                                          :class="fls.type"
                                          :key="i"
                                          :for="fls.data + '-' + i"
                                          :id="'label-' + fls.data + '-' + i"
                                          class="mr-5"
                                        >
                                          <input
                                            :type="fls.type"
                                            :id="fls.data + '-' + i"
                                            :name="fls.data + '-' + i"
                                            :value="o.code"
                                            v-model="modelData[fls.data]"
                                          />
                                          <span></span>
                                          <a
                                            :id="'text-' + fls.data + '-' + i"
                                            >{{ o.label ? o.label : o }}</a
                                          >
                                        </label>
                                        <b-popover
                                          v-if="o.tooltip"
                                          :key="i + '-option-tooltip'"
                                          :target="'text-' + fls.data + '-' + i"
                                          :title="
                                            o.label
                                              ? 'Keterangan ' + o.label
                                              : 'Keterangan ' + o
                                          "
                                          triggers="hover"
                                          :placement="'right'"
                                          :boundary="'window'"
                                        >
                                          <div
                                            v-for="(t, i) in o.tooltip"
                                            :key="i + '-tooltip-body'"
                                          >
                                            <span class="font-weight-bold">{{
                                              t.title
                                            }}</span>
                                            <p class="mt-0">{{ t.data }}</p>
                                          </div>
                                        </b-popover>
                                      </template>
                                    </div>
                                    <p v-else class="p-0">
                                      {{ $t("error.no_data") }}
                                    </p>
                                  </template>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </ValidationProvider>
                              </div>
                            </template>
                            <!-- Type Lookup -->
                            <template v-else-if="lookupType.includes(fls.type)">
                              <div
                                class="form-group"
                                :key="ix + '-field'"
                                v-if="fls.show"
                              >
                                <ValidationProvider
                                  mode="aggressive"
                                  :name="fls.label"
                                  :rules="fls.validation.join('|')"
                                  v-slot="{ classes, errors }"
                                >
                                  <label
                                    >{{ fls.label }}
                                    <span
                                      v-if="fls.validation.includes('required')"
                                      class="text-danger"
                                      >*</span
                                    ></label
                                  >
                                  <lookup-input
                                    v-on="fls.event"
                                    v-model="modelData[fls.data]"
                                    :defaultData="{
                                      id: fls.id,
                                      data: defaultData,
                                    }"
                                    :multiple="fls.type === 'lookup-checkbox'"
                                    :endpoint="fls.getter"
                                    :param="tmp_param[fls.id]"
                                    :errors="errors"
                                    :title="fls.label"
                                    :pointer="fls.option.list_pointer"
                                    :classes="
                                      fls.validation.length === 0 ? {} : classes
                                    "
                                    :placeholder="fls.placeholder"
                                    :allowAdd="fl.option.allowAdd"
                                  />
                                </ValidationProvider>
                              </div>
                            </template>
                          </div>
                        </div>
                        <!-- end row slave  -->
                        <!-- <b-row v-for="(item, index) in form.items" :id="item.id" :key="index" ref="row">
                          <h1>asd</h1>
                        </b-row> -->
                        <!-- <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="gradient-primary" @click="addRecord">
                          <feather-icon icon="PlusIcon" class="mr-25" />
                          <span>Tambah</span>
                        </b-button> -->
                        <button
                          @click="addRecord"
                          class="btn btn-light-primary mr-3"
                        >
                          Tambah
                        </button>
                      </div>
                    </template>
                    <!-- end type slave  -->
                    <template v-else>
                      <div class="form-group" :key="ix + '-field'">
                        <label>
                          {{ $t("error.view_type") }} ({{ fl.type }}) |
                          {{ fl.label }}</label
                        >
                      </div>
                    </template>
                    <!-- </div> -->
                    <div v-if="fl.separator" class="separator"></div>
                  </div>
                </template>
                <template v-if="simple">
                  <div class="col-12 align-self-center">
                    <slot name="form-btn-action" />
                    <button type="submit" class="btn btn-light-primary mr-3">
                      <span class="mr-1">
                        {{ btnSaveLabel ? btnSaveLabel : $t("global.submit") }}
                      </span>
                    </button>
                    <button
                      v-if="form === 'filter'"
                      type="button"
                      class="btn btn-secondary"
                      @click="resetForm()"
                    >
                      Reset
                    </button>
                  </div>
                </template>
              </div>
              <div v-if="!simple" class="d-flex justify-content-between py-5">
                <div class="d-flex flex-row align-items-center">
                  <slot name="form-btn-action" />
                  <button
                    v-if="form === 'create'"
                    type="submit"
                    :disabled="isLoading"
                    class="btn btn-primary btn-spinner mr-3"
                  >
                    <i class="ri-save-line"></i>
                    <span class="mr-1">
                      {{ btnSaveLabel ? btnSaveLabel : $t("global.submit") }}
                    </span>
                    <b-spinner
                      v-if="isLoading"
                      variant="light"
                      small
                    ></b-spinner>
                  </button>
                  <button
                    v-if="form === 'update'"
                    type="submit"
                    :disabled="isLoading"
                    class="btn btn-primary btn-spinner mr-3"
                  >
                    {{ btnSaveLabel ? btnSaveLabel : $t("global.submit_edit") }}
                  </button>
                  <!-- <b-button variant="light"  :disabled="isLoading"  @click="$router.go(-1)">Batal</b-button> -->
                </div>
                <button
                  v-if="form === 'filter'"
                  :disabled="isLoading"
                  type="button"
                  class="btn btn-secondary"
                  @click="resetForm()"
                >
                  Reset
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "main-form",
  props: {
    form: { type: String, required: true },
    title: { type: String, required: true },
    titleKey: {
      type: String,
      required: false,
      default: () => null,
    },
    fields: { type: Array, required: true },
    API: { type: Object, required: true },
    id: { type: Number, required: false },
    hideBtnBack: { type: Boolean, required: false, default: false },
    btnSaveLabel: { type: String, required: false, default: "" },
    customGetter: { type: Boolean, required: false, default: false },
    simple: { type: Boolean, required: false, default: false },
    slave: { type: Boolean, required: false, default: false },
    updateConfig: { type: Object, required: false, default: () => ({}) },
    createConfig: { type: Object, required: false, default: () => ({}) },
  },
  data() {
    return {
      isReady: false,
      modelData: [],
      defaultCaption: {},
      defaultData: null,
      defaultType: ["text", "email", "hidden", "password", "tel", "url"],
      numberType: ["number", "money"],
      dateType: ["date", "datetime", "year", "month", "time", "week"],
      dateRangeType: [
        "date-range",
        "datetime-range",
        "year-range",
        "month-range",
        "time-range",
        "week-range",
      ],
      textType: ["textarea"],
      fileType: ["file", "file-multiple"],
      optionType: ["select", "select-multiple", "checkbox", "radio"],
      lookupType: ["lookup-checkbox", "lookup-radio", "select"],
      tmp_option: {},
      tmp_option_default: {},
      tmp_param: {},
      tmp_field: {},
      tempData: null,
      useContactCheck: false,
      isLoading: false,
    };
  },
  mounted() {
    this.modelData = this.buildModelData();
    this.checkDefaultValue().then(async (e) => {
      if (this.form === "update") await this.getValueAPI();
      this.buildParamOption().then((f) => {
        // form loaded
      });
    });

    if (this.$route.query.view === "create") {
      this.isReady = true;
    }
  },

  computed: {
    corporate() {
      return this.$store.getters.corporate;
    },
  },

  watch: {
    useContactCheck(to) {
      if (to) {
        this.modelData.email = this.corporate.email;
        this.modelData.phone = this.corporate.phone;
      }
    },
  },

  methods: {
    buildModelData() {
      let _temp = {};

      if (this.form === "update") {
        for (const field of this.fields) {
          _temp[field.view_data || field.id] = null;
          if (field.dataLabel) {
            _temp[field.dataLabel] = null;
          }
        }
      } else {
        _temp = this.fields.reduce(
          (ac, a) => ({ ...ac, [a.view_data]: a.value }),
          {}
        );
      }

      let _field = {};
      Object.keys(_temp).forEach((e) => {
        let _mask = e;
        if (e.indexOf(".")) {
          _mask = e.split(".")[0];
          this.$set(this.tmp_field, _mask, e);
        }
        _field[_mask] = _temp[e];
      });

      return _field;
    },
    formatDate(type) {
      let _format;
      switch (type) {
        case "date":
        case "date-range":
          _format = "YYYY-MM-DD";
          break;
        case "datetime":
        case "datetime-range":
          _format = "YYYY-MM-DD HH:mm:ss";
          break;
        case "year":
        case "year-range":
          _format = "YYYY";
          break;
        case "month":
        case "month-range":
          _format = "YYYY-MM";
          break;
        case "time":
        case "time-range":
          _format = "HH:mm:ss";
          break;
        case "week":
        case "week-range":
          _format = "DD";
          break;
      }
      return _format;
    },
    emitEvent(e, data = null) {
      const value = data || true;
      this.$emit(e, value);
    },
    async checkDefaultValue() {
      if (this.slave)
        this.$set(
          this.modelData,
          this.$store.state.activeSlave.param,
          this.$store.state.activeSlave.key
        );
      await this.fields.forEach((e) => {
        if (
          e.type === "checkbox" ||
          e.type === "select-multiple" ||
          e.type === "lookup-checkbox" ||
          e.type === "file-multiple" ||
          e.type === "slave"
        ) {
          if (!Array.isArray(this.modelData[e.data]))
            this.$set(this.modelData, e.data, []);
        }
        if (
          this.$_config.options.autofill &&
          this.$store.state.autofill[e.data]
        ) {
          if (this.slave && this.$store.state.activeSlave.param !== e.data)
            this.$set(
              this.modelData,
              e.data,
              this.$store.state.autofill[e.data].value
            );
          else
            this.$set(
              this.modelData,
              e.data,
              this.$store.state.autofill[e.data].value
            );
        }
      });
    },
    async buildParamOption() {
      let newField = this.fields.filter(
        (x) =>
          this.optionType.includes(x.type) || this.lookupType.includes(x.type)
      );
      await newField.forEach((e) => {
        if (
          e.getter &&
          e.option &&
          e.option.get_param &&
          e.option.get_param.length > 0
        ) {
          e.option.get_param.forEach((el) => {
            this.setWatcher(
              this.fields.filter((x) => x.id === el.id)[0],
              el.alias ? el.alias : el.id,
              e
            );
          });
        } else if (e.getter) {
          if (this.optionType.includes(e.type))
            this.getOptionData(e.getter, e.option.filterAPI || null, e);
          if (this.lookupType.includes(e.type)) {
            if (!this.tmp_param[e.id]) this.$set(this.tmp_param, e.id, {});
            this.tmp_param[e.id] = Object.assign(
              {},
              this.tmp_param[e.id],
              e.option.filterAPI
            );
          }
        } else {
          if (e.option.list_pointer.list)
            this.assignOptionData(e.option.list_pointer.list, e);
          else this.assignOptionData([], e);
        }
      });
      this.fields.forEach((e) => {
        if (
          e.option &&
          e.option.toggle_field &&
          Array.isArray(e.option.toggle_field)
        ) {
          e.option.toggle_field.forEach((f) => {
            this.setWatcherToggle(
              this.fields.filter((x) => x.id === f.id)[0],
              f,
              e
            );
          });
        }
      });
    },
    setWatcherToggle(target, toggle, owner) {
      this.$watch(
        "modelData." + owner.data,
        function (t, f) {
          let meetCondition;
          if (typeof toggle.value === "boolean")
            meetCondition = Boolean(t) === Boolean(toggle.value);
          else if (Array.isArray(toggle.value))
            meetCondition = toggle.value.includes(t);
          else meetCondition = Boolean(t === toggle.value);

          if (meetCondition) this.$set(target, [toggle.item], toggle.toggle[0]);
          else this.$set(target, [toggle.item], toggle.toggle[1]);
        },
        { deep: false, immediate: true }
      );
    },
    setWatcher(target, alias, owner) {
      this.$watch(
        "modelData." + target.data,
        function (t, f) {
          // check if param exist
          if (!this.tmp_param[owner.id])
            this.$set(this.tmp_param, owner.id, {});
          const haveParam = owner.getter.split("?")[1];
          if (haveParam) {
            haveParam.split(",").forEach((x) => {
              this.$set(
                this.tmp_param[owner.id],
                x.split("=")[0],
                x.split("=")[1]
              );
            });
          }
          // assign new param
          this.$set(this.tmp_param[owner.id], alias, t);

          this.getOptionData(
            owner.getter.split("?")[0],
            this.tmp_param[owner.id],
            owner,
            true
          );
        },
        { deep: true, immediate: false }
      );
    },
    getOptionData(endpoint, filter, field, watcher = false) {
      if (field.type === "select" && this.defaultData) {
        let _val = [];

        if (!field.option.list_pointer.defaultCaption) {
          for (let display of field.option.list_pointer.display) {
            const labelKey = field.option.list_pointer.defaultCaption
              ? field.option.list_pointer.defaultCaption
              : `${field.id}_${display}`;

            if (this.defaultData[labelKey]) {
              _val.push(this.defaultData[labelKey]);
            }
          }
        }

        let customCaptions = [];
        if (
          field.option.list_pointer.defaultCaption &&
          Array.isArray(field.option.list_pointer.defaultCaption)
        ) {
          customCaptions = field.option.list_pointer.defaultCaption;
        } else if (
          field.option.list_pointer.defaultCaption &&
          !Array.isArray(field.option.list_pointer.defaultCaption)
        ) {
          customCaptions = [field.option.list_pointer.defaultCaption];
        }
        for (const display of customCaptions) {
          if (this.defaultData[display]) {
            _val.push(this.defaultData[display]);
          }
        }

        if (_val.length > 0) {
          this.$set(
            this.defaultCaption,
            field.id,
            `${_val.join(field.option.list_pointer.separator || ", ")}`
          );
        }

        if (field.dataLabel) {
          this.$set(
            this.defaultCaption,
            field.id,
            this.defaultData[field.dataLabel]
          );
        }
      }
      // this.$_api.dataset(endpoint, filter).then(res => {
      //   this.assignOptionData(res.data, field)
      //   // reset field value if from watcher
      //   if (watcher) {
      //     if (field.type === 'checkbox' || field.type === 'select-multiple' || field.type === 'lookup-checkbox') {
      //       if (!Array.isArray(this.modelData)) this.$set(this.modelData, field.data, [])
      //     } else this.$set(this.modelData, field.data, null)
      //   }
      // }, err => {
      //   this.$_alert.error(err, null, 'Cannot get ' + field.label.replace(/\b\w/g, l => l.toUpperCase()) + ' datalist')
      // })
    },
    assignOptionData(data, owner) {
      if (typeof data[0] === "object") {
        this.$set(
          this.tmp_option,
          owner.id,
          data.map((x) => {
            return {
              label: x[owner.option.list_pointer.label],
              code: x[owner.option.list_pointer.code],
              tooltip: owner.option.list_pointer.tooltip
                ? owner.option.list_pointer.tooltip.map((y) => {
                    return { title: y.title, data: x[y.data] };
                  })
                : null,
            };
          })
        );
        this.$set(this.tmp_option_default, owner.id, data);
      } else {
        this.$set(this.tmp_option, owner.id, data);
        this.$set(this.tmp_option_default, owner.id, data);
      }
    },
    revertDataArray(key) {
      if (this.tmp_option_default[key]) {
        let newData = [];
        let owner = this.fields.filter((x) => x.data === key)[0];
        this.modelData[key].forEach((val) => {
          newData.push(
            this.tmp_option_default[key].filter(
              (x) => x[owner.option.list_pointer.code] === val
            )[0]
          );
        });
        return newData;
      } else return this.modelData[key];
    },
    revertNumberType(value) {
      if (value) {
        const numberPattern = /\d+/g;
        return Number(String(value).match(numberPattern).join(""));
      } else return value;
    },
    async onSubmit() {
      this.isLoading = true;
      const isValid = await this.$refs.baseForm.validate();
      if (!isValid) {
        this.isLoading = false;
        return;
      }
      let formData = {};
      Object.keys(this.modelData).forEach((e) => {
        if (
          this.modelData[e] instanceof Array &&
          !(this.modelData[e][0] instanceof Object)
        ) {
          this.$set(formData, e, this.revertDataArray(e));
        } else this.$set(formData, e, this.modelData[e]);
      });

      let sendData = { ...this.defaultData, ...formData };
      if (this.form === "create") {
        this.$_api
          .create(this.API.setter, sendData)
          .then((res) => {
            this.isLoading = false;
            this.$emit("success", res.data);
          })
          .catch((err) => {
            this.isLoading = false;
            this.$_alert.error(err);
          });
      } else if (this.form === "update") {
        this.$_api
          .update(this.API.setter, sendData)
          .then((res) => {
            this.isLoading = false;
            this.$emit("success", res.data);
          })
          .catch((err) => {
            this.isLoading = false;
            this.$_alert.error(err);
          });
      } else {
        this.isLoading = false;
        this.$emit("success", sendData);
      }
    },
    resetForm() {
      Object.keys(this.modelData).forEach((e) => {
        if (this.modelData[e] instanceof Array) {
          this.$set(this.modelData, e, []);
        } else if (this.modelData[e] instanceof Object) {
          this.$set(this.modelData, e, {});
        } else this.$set(this.modelData, e, null);
      });
    },
    async getValueAPI() {
      if (!this.customGetter) {
        await this.$_api
          .single(this.API.getter, null, this.id)
          .then((res) => {
            let data = res.data;
            this.defaultData = data;
            Object.keys(this.modelData).forEach((e) => {
              let _data = data[e];
              if (this.tmp_field[e])
                _data = this.renderVal(data, this.tmp_field[e]);
              this.$set(this.modelData, e, _data);
              this.isReady = true;
            });
          })
          .catch((err) => {
            this.$_alert.error(err);
          });
      } else {
        await this.$_api
          .get(this.API.getter, { id: this.id })
          .then((res) => {
            let data = res.data;
            this.defaultData = data;

            Object.keys(this.modelData).forEach((e) => {
              let _data = data[e];
              if (this.tmp_field[e])
                _data = this.renderVal(data, this.tmp_field[e]);
              this.$set(this.modelData, e, _data);
              this.isReady = true;
            });
          })
          .catch((err) => {
            this.$_alert.error(err);
          });
      }
    },
    renderVal(source, prop) {
      let _index = prop.indexOf(".");
      if (_index > -1) {
        let e = prop.split(".");
        for (let i = 0; i < e.length; i++) {
          if (source[e[i]]) source = source[e[i]];
          else {
            if (Array.isArray(source)) {
              let tmp = [];
              source.forEach((el) => {
                tmp.push(el[e[i]]);
              });
              source = tmp;
            }
          }
        }
        return source;
      } else return source[prop];
    },

    addRecord() {
      // this.form.items.push({
      //   id: null,
      //   expense_id: null,
      //   total: null
      // })
      // this.$nextTick(() => {
      //   this.trAddHeight(this.$refs.row[0].offsetHeight)
      // })
    },
    removeItem(index) {
      this.form.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
      this.getTotal();
    },
  },
};
</script>
<style>
.mx-datepicker.is-invalid input {
  border-color: #f64e60;
  padding-right: calc(1.5em + 1.3rem);
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.325rem) center;
  background-size: calc(0.75em + 0.65rem) calc(0.75em + 0.65rem);
}

.mx-datepicker.is-valid input {
  border-color: #3699ff;
  padding-right: calc(1.5em + 1.3rem);
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.325rem) center;
  background-size: calc(0.75em + 0.65rem) calc(0.75em + 0.65rem);
}

.vs-style .vs__dropdown-toggle {
  border: 1px solid #e4e6ef;
  border-radius: 0.42rem;
  padding: 0.8rem 1rem;
}
/*
                        .style-chooser .vs__search::placeholder,
                        .style-chooser .vs__dropdown-toggle,
                        .style-chooser .vs__dropdown-menu {
                          background: #dfe5fb;
                          border: none;
                          color: #394066;
                          text-transform: lowercase;
                          font-variant: small-caps;
                        } */

.vs-style.is-invalid .vs__dropdown-toggle {
  border-color: #f64e60;
}

.vs-style.vs--single .vs__selected,
.vs-style .vs__search,
.vs-style .vs__actions {
  padding: 0;
  border: none;
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #333 !important;
  background-color: transparent !important;
}

.vs-style .vs__selected {
  margin-top: 0;
  margin-left: 0;
  color: #ffffff;
  background-color: #226638;
  border: none;
}

.vs-style .vs__selected button {
  margin-left: 0.5rem;
}

.vs-style .vs__search::placeholder {
  color: #b5bcd4;
}

.separator {
  border-bottom: 1px dashed #e0e8f0;
  padding: 1em 2.5em;
}
</style>



// WEBPACK FOOTER //
// src/base/main-form.vue